import Vue from "vue";
import Router from "vue-router";

import Dashboard from "./views/Dashboard.vue";
import Projects from "./views/Projects.vue";
import Track from "./views/Track.vue";
import TrackMaster from "./views/TrackMaster.vue";
import Login from "./views/Login.vue";
import CreateAccount from "./views/CreateAccount.vue";
import ForgotPassword from "./views/ForgotPassword.vue";
import ResetPassword from "./views/ResetPassword.vue";
import Logout from "./views/Logout.vue";
import NProgress from "nprogress";
import store from "@/store/store";
import UploadV2 from "./views/NewUpload.vue";
import CustomOrder from "./views/CustomUpload.vue";
import Mastering from "./views/Mastering.vue";
import Revise from "./views/Revise.vue";
import ShopifyCheckout from "./views/ShopifyCheckout";
import CustomOrderThanks from "./views/CustomOrderThanks.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/shopify-checkout",
      name: "shopify-checkout",
      component: ShopifyCheckout,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/guest-shopify-checkout",
      name: "guest-shopify-checkout",
      component: ShopifyCheckout,
      meta: {
        guest: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: "/custom-order",
      name: "customOrder",
      component: CustomOrder,
      meta: {
        guest: true
      }
    },
    {
      path: "/custom-track-success",
      name: "customOrderThanks",
      component: CustomOrderThanks,
      meta: {
        guest: true
      }
    },
    {
      path: "/createAccount",
      name: "create-account",
      component: CreateAccount,
      meta: {
        guest: true
      }
    },
    {
      path: "/forgotPassword",
      name: "forgot-password",
      component: ForgotPassword,
      meta: {
        guest: true
      }
    },
    {
      path: "/resetPassword",
      name: "reset-password",
      component: ResetPassword,
      meta: {
        guest: true
      },
      beforeEnter(to, from, next) {
        store
          .dispatch("apiEvents/resetPasswordCheck", {
            token: to.query.token,
            username: to.query.username
          })
          .then(() => {
            to.params.valid = true;
            next();
          })
          .catch(() => {
            to.params.valid = false;
            next();
          });
      }
    },
    {
      path: "/logout",
      name: "logout",
      component: Logout,
      meta: {
        guest: true
      }
    },
    {
      path: "/mastering",
      name: "mastering",
      component: Mastering,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: "/uploadtrack",
    //   name: "uploadtrack",
    //   component: Upload,
    //   meta: {
    //     requiresAuth: true,
    //   },
    // },
    {
      path: "/uploadtrack",
      name: "uploadtrack",
      component: UploadV2,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true
      },
      beforeEnter(routeTo, routeFrom, next) {
        store.dispatch("trackData/clearAllTrackData").then(() => {
          next();
        });
      }
    },
    {
      path: "/projects",
      name: "projects",
      component: Projects,
      meta: {
        requiresAuth: true
      },
      beforeEnter(routeTo, routeFrom, next) {
        store.dispatch("trackData/clearAllTrackData").then(() => {
          next();
        });
      }
    },
    {
      path: "/track/:id/revise",
      name: "revise",
      component: Revise,
      meta: {
        requiresAuth: true
      },
      beforeEnter(routeTo, routeFrom, next) {
        store.dispatch("trackData/clearAllTrackData").then(() => {
          next();
        });
      }
    },
    {
      path: "/track/:id",
      name: "track",
      component: Track,
      meta: {
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        if (to.name == "track") {
          if (to.params.id != 0) {
            store
              .dispatch("trackData/setRefStemElements", to.params.id)
              .then(() => {
                store
                  .dispatch("trackData/setexistingStems", to.params.id)
                  .then(() => {
                    store
                      .dispatch(
                        "trackData/fetchFinshedTracksByTrackId",
                        to.params.id
                      )
                      .then(() => {
                        store
                          .dispatch(
                            "trackData/fetchFinshedTracksByTrackId",
                            to.params.id
                          )
                          .then(() => {
                            store
                              .dispatch("trackData/setAllTrackData", {
                                trackId: to.params.id
                              })
                              .then(() => {
                                next();
                              });
                          });
                      });
                  });
              });
          } else {
            next();
          }
        } else {
          next();
        }
      }
    },
    {
      path: "/track/master/:id",
      name: "track-master",
      component: TrackMaster,
      meta: {
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        if (to.name == "track-master") {
          if (to.params.id != 0) {
            store
              .dispatch("trackData/setRefStemElements", to.params.id)
              .then(() => {
                store
                  .dispatch("trackData/setexistingStems", to.params.id)
                  .then(() => {
                    store
                      .dispatch(
                        "trackData/fetchFinshedTracksByTrackId",
                        to.params.id
                      )
                      .then(() => {
                        store
                          .dispatch(
                            "trackData/fetchFinshedTracksByTrackId",
                            to.params.id
                          )
                          .then(() => {
                            store
                              .dispatch("trackData/setAllTrackData", {
                                trackId: to.params.id
                              })
                              .then(() => {
                                next();
                              });
                          });
                      });
                  });
              });
          } else {
            next();
          }
        } else {
          next();
        }
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  //there's a possiblility we need to add some logic here
  //to check for the JWT token before pulling userId, etc

  const jwt = localStorage.getItem("jwt");

  if (!jwt && to.path === "/shopify-checkout") {
    next({
      path: "/guest-shopify-checkout",
      query: to.query
    });
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (
      Object.keys(store.state.apiEvents.userTracks).length == 0 ||
      to.name == "dashboard" ||
      to.name == "projects"
    ) {
      store
        .dispatch("apiEvents/fetchTracksByUserId", {
          id: localStorage.getItem("userId")
        })
        .then(() => {
          store
            .dispatch("apiEvents/fetchProjectsByUserId", {
              id: localStorage.getItem("userId")
            })
            .then(() => {
              store.dispatch("apiEvents/setUserDetails").then(() => {
                next();
              });
            });
        });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.beforeEach((routeTo, routeFrom, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

router.beforeEach((to, from, next) => {
  if (to.name == "logout") {
    store.dispatch("apiEvents/logout");
    next({ name: "login" });
  }
  if (localStorage.getItem("jwt") != null && store.state.apiEvents.jwt == "") {
    store.dispatch("apiEvents/setUserDetails");
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt") === null) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
        query: to.query
      });
    } else {
      let user = JSON.parse(localStorage.getItem("user"));
      if (to.matched.some(record => record.meta.is_admin)) {
        if (user.is_admin == 1) {
          next();
        } else {
          next({ name: "dashboard" });
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem("jwt") === null) {
      next();
    } else {
      next({ name: "dashboard" });
    }
  } else {
    next({ name: "login" });
  }
});

export default router;
